// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/detailed-product-card/detailed-product-card.component.scss
// module id = 263
// module chunks = 0